import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  bottom: 37px;
  right: 135px;
  border: 1px solid var(--global-color-gray-400);
  border-radius: 4px;
  z-index: 9;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  > div:first-of-type {
    border-radius: 4px;
  }
`
